import React, {useEffect, useState} from "react";
import {
    CardMedia,
    CircularProgress,
    Dialog,
    Grid,
    IconButton,
    Stack,
    Tooltip,
    Typography,
    useTheme,
    Skeleton
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "axios";
import {FileIcon} from "react-file-icon"
import ClearIcon from "@mui/icons-material/Clear";
import moment from "moment";
import {noop} from 'lodash';
import {styled} from "@mui/material/styles";
import MDTypography from "../MDTypography";
import CircularWithValueLabel from "./CircularProgressWithLabel";
import {useSelector} from "react-redux";
import api from "../../api/api";
import LocalStorage from "../../utils/LocalStorage";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {useTranslation} from "react-i18next";


const actionType = {
    UPLOAD: 'upload',
    DELETE: 'delete'
}


export const fileTypes = {
    PNG: 'png',
    JPG: 'jpg',
    JPEG: 'jpeg',
    DOC: 'doc',
    DOCX: 'docx',
    PDF: 'pdf',
    TXT: 'txt',
    RAR: 'rar',
    ZIP: 'zip',
    excel: 'csv',
    svg: 'svg',
    ppt: 'ppt',
    pptx: 'pptx',
    gif: 'gif',
    xlsx: 'xlsx'
}

export function MyFileUploader({
                                   acceptDefaultTypes = true,
                                   baseFileURL = '',
                                   onSuccess = noop,
                                   onError = noop,
                                   fileType,
                                   maxKB = (5 * 1024),
                                   list,
                                   color,
                                   asFormInputComponent = false,
                                   handleImageCallBack = noop,
                                   multipleFile = true,
                                   register,
                                   owner,
                                   uploadDisabled = false
                               }) {

    const MyContainer = styled(Stack)(({theme}) => ({
        margin: theme.spacing(3),
        backgroundColor: theme.palette.background.container,
        padding: '1rem',
        maxWidth: '500px',
    }))

    const MyUploaderContainer = styled(Grid)(({theme}) => ({
        padding: '2rem',
        border: `2px dashed ${theme.palette.primary.main}`,
        textAlign: 'center',
        fontSize: 'small',
        backgroundColor: theme.palette.background.default,
    }))

    const MyDisplayFiles = styled(Grid)(({theme}) => ({
        marginTop: '1rem'
    }))

    const MyFileGrid = styled(Grid)(({theme}) => ({
        border: `1px dashed ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.background.default,
        padding: '0.5rem',
        marginBottom: '5px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'center'
    }))

    const MyMediaGrid = styled(Grid)(({theme}) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px'
    }))

    const [fileList, setFileList] = useState([])
    const [uploaded, setUploaded] = useState(null)
    const [progress, setProgress] = useState(0)
    const [supportedType, setSupportedType] = useState([])
    const [previewUrl, setPreviewUrl] = useState('')
    const [modelFile, setModelFile] = useState({})
    const [modelOpen, setModelOpen] = useState(false)
    const [resourceCancelToken, setResourceCancelToken] = useState(axios.CancelToken.source())
    const [uploading, setUploading] = useState(false)
    const darkMode = useSelector(state => state?.common?.darkMode)
    const theme = useTheme()
    const {t, i18n} = useTranslation();


    useEffect(() => {

        if (list?.length !== 0) {
            setFileList(() => [...list])
        } else if (!asFormInputComponent) {
            setFileList(() => fileList.filter(v => v.beforeUploaded === false))
        }
    }, [list])

    useEffect(() => {
        let tempArr = []
        if (acceptDefaultTypes) {
            // for (const k in fileTypes) {
            //   tempArr = [...tempArr,fileTypes[k]]
            // }
            Object.keys(fileTypes).forEach(v => {
                tempArr = [...tempArr, fileTypes[v]];
                return null
            })

            setSupportedType([...tempArr])
        } else {

            setSupportedType([...fileType.split(',')])
        }

    }, [])

    useEffect(() => {
        if (uploaded) {
            fileList[0] = uploaded
            setProgress(0)
        }
    }, [uploaded])

    useEffect(() => {

        handleImageCallBack(fileList.map(({file}) => file))
        setProgress(0)
        setUploaded(null)
    }, [fileList])


    function convertAcceptTypeToString(typeArr, char) {
        let typeStr = ''
        typeArr.forEach((v, i) => {
                if (i === 0) {
                    typeStr += v
                } else {
                    typeStr = typeStr + char + v
                }
            }
        )
        return typeStr
    }

    const convertToInputAccept = typeArr => {
        let typeStr = ''
        typeArr.forEach(v => {
            typeStr = `${typeStr}.${v},`
        })
        return typeStr
    }

    const uploadConfig = {
        onUploadProgress: (progressEvent) => {
            const progressNum = Math.trunc((progressEvent.loaded / progressEvent.total) * 100);
            setProgress(progressNum)
        },
        cancelToken: resourceCancelToken?.token
    }


    const uploadHandler = async event => {

        const file = event?.target?.files[0]

        if (file === undefined) {
            return {}
        }
        const name = event?.target?.files[0]?.name
        const title = name.substring(0, name.indexOf("."))
        if (file.size > (1024 * maxKB)) {
            onError(`file cannot over ${maxKB}KB`)
            return {}
        }
        
        setUploading(true);

        // create new formData
        const formData = new FormData()
        formData.append('title', title)
        formData.append('filename', name)
        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            if (!owner?.ownerName){
                setUploading(false)
                return onError(t('Please Choose Owner before Admin upload CSV'))
            }else{
                formData.append("userName", owner?.ownerName);
            }
        }
        if (!checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            formData.append("userName", LocalStorage.getItem('username'));
        }
        formData.append('isAdmin',checkPermission(PERMISSION_DICT.QueryOwnerInfo))
        formData.append('file', file)
        setPreviewUrl(URL.createObjectURL(file))


        // upload new file
        let currentUploading
        if (asFormInputComponent) {
            currentUploading = {
                'title': title,
                'filename': name,
                'file': file,
                'isUploading': false,
                'url': URL.createObjectURL(file)
            }
            if (multipleFile) {
                setFileList(() => [currentUploading, ...fileList])
            } else {
                setFileList(() => [...[], currentUploading])
            }
        } else {

            if (multipleFile) {
                setFileList(() => [currentUploading, ...fileList])
            } else {
                setFileList(() => [...[], currentUploading])
            }
            currentUploading = {'title': title, 'filename': name, 'file': file, 'isUploading': true}
            try {


                const res = await api.post(baseFileURL, formData, uploadConfig).then(res => res)


                if (res?.status === 200 && res.data.code === 200) {
                    setUploaded({
                        'filename':name,
                        'beforeUploaded': false,
                        'isUploading': false,
                        'url': URL.createObjectURL(file)
                    })
                    setUploading(false);
                    return onSuccess(`${t('Upload')} ${name} ${t('successfully')}`, actionType.UPLOAD)
                }
                setUploading(false);
                return onError(res.data?.msg || 'Error uploading resource file', actionType.UPLOAD)
            } catch (e) {
                setUploading(false);
                if (axios.isCancel(e)) {
                    return onSuccess('upload request cancel', actionType.UPLOAD)
                }
                return onError('Error in uploading file', actionType.UPLOAD)

            }
        }
        return false
    }

    const deleteResource = (file, uploading, onSuccessReturn, onErrors) => async () => {
        if (asFormInputComponent) {
            setFileList(fileList.filter(v => v !== file))
            return {}
        }
        if (uploading) {
            resourceCancelToken.cancel()
            setResourceCancelToken(axios.CancelToken.source())
            fileList.shift()
        } else {
            try {
                // const url = `${baseFileURL}/${file?.id}`
                // const res = await api.delete(url)
                // if (res.data?.rs) {
                //     setFileList(fileList.filter(v => v.id !== file?.id))
                //     setProgress(0)
                //     return onSuccessReturn(res.data?.message || 'Resource is deleted successfully', actionType.DELETE, {
                //         id: file?.id,
                //         filename: file?.filename
                //     })
                // }
                return onErrors("The file already upload cannot be deleted", actionType.DELETE)
            } catch (e) {
                onErrors('The uploaded file cannot be deleted.', actionType.DELETE, {id: file?.id, filename: file?.filename})
            }
        }
        return false
    }


    const downloadFile = file => {
        const link = document.createElement('a')
        link.setAttribute('target', "_blank")
        link.href = file?.url
        link.download = file?.filename
        document.body.appendChild(link)
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: false, view: window}));
        link.parentNode.removeChild(link);
    }

    const fileGrid = (file, progressValue, isUploading = false) => {



        const ext = file?.filename?.split('.').pop()
        const image = ['png', 'jpg', 'jpeg', 'svg', 'gif']
        const showingImage = image.includes(file?.filename?.split('.').pop())
        const previewObject = ['pdf']
        const showingObject = previewObject.includes(file?.filename?.split('.').pop())


        return (
            <MyFileGrid container>
                <MyMediaGrid item xs={2} container>
                    {
                        showingImage
                            ?
                            <CardMedia
                                component="img"
                                image={isUploading ? previewUrl : file.url}
                                alt={file?.filename}
                                onClick={() => {
                                    setModelOpen(true)
                                    setModelFile(isUploading ? {...file, 'url': previewUrl} : file)
                                }}/>
                            : (
                                showingObject ?
                                    <Grid aria-hidden="true"
                                          role="button"
                                          tabIndex={0}
                                          onClick={
                                              () => {
                                                  setModelOpen(true)
                                                  setModelFile(isUploading ? {...file, 'url': previewUrl} : file)
                                              }}
                                    >
                                        <object width='50' height='50' aria-hidden="true"
                                                style={{pointerEvents: 'none'}}
                                                data={isUploading ? previewUrl : file?.url}
                                                aria-label="previewUrlToObject"
                                        />

                                    </Grid>
                                    :
                                    <Grid style={{width: '50px', height: '100%', padding: '0px'}}><FileIcon extension={ext}
                                                                                                            color={'#1A73E8'}/></Grid>

                            )
                    }


                </MyMediaGrid>
                <Grid item container xs={9} justifyContent='space-between' alignItems='center' spacing={2}
                      style={{textAlign: 'start', padding: '5px', fontSize: 'small', fontWeight: 'bold'}}>
                    <Grid item container xs={10} flexDirection='column' flexWrap={'wrap'}>
                        <Grid item xs={12} onClick={() => downloadFile(file)} style={{cursor: 'pointer'}}>
                            <MDTypography sx={{wordWrap: 'break-word', wordBreak: 'break-all'}}
                                          variant={'block'}>{file?.filename}</MDTypography>
                        </Grid>
                        <Grid item xs={12}>
                            <h6 style={{color: 'grey'}}>{moment(file?.createdAt).format('LLL')}</h6>
                        </Grid>
                    </Grid>
                    {!asFormInputComponent &&
                        <Grid item xs={2} id={'ssssss'}>
                            <CircularWithValueLabel value={isUploading ? progressValue : 100}/>
                        </Grid>}
                </Grid>
                <Grid item xs={1}>
                    <Tooltip title="Delete">
                        <IconButton onClick={
                            deleteResource(file, isUploading, onSuccess, onError)
                        }>
                            <ClearIcon/>
                        </IconButton>
                    </Tooltip>
                </Grid>
            </MyFileGrid>
        )

    }


    return (
        <MyContainer>
            <Grid container>
                <MyUploaderContainer item container xs={12}>
                        <Grid xs={12} item>
                            {uploading ? <Skeleton animation="wave"/> :
                                <IconButton disabled={uploadDisabled} color="primary" aria-label="upload picture" component="label">
                                    <input hidden accept={convertToInputAccept(supportedType)} type="file"
                                           onChange={uploadHandler} ref={register}/>
                                    <CloudUploadIcon fontSize="large"/>
                                </IconButton>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            {uploading ? <Skeleton animation="wave"/> :
                            <MDTypography display="block" color={'text'} sx={{fontSize: 'medium'}}
                                          xs={12}>{ `${t('Max')} ${maxKB}kb`}</MDTypography>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            {uploading ? <Skeleton animation="wave"/> :
                            <MDTypography display="block" color={'text'} sx={{fontSize: 'medium'}} xs={12}>
                                {`${t('Supported Types')}: ${convertAcceptTypeToString(supportedType, ', ')}`}
                            </MDTypography>
                            }
                        </Grid>

                </MyUploaderContainer>

            </Grid>
            <MyDisplayFiles item xs={12}>
                {fileList.map((value) => <div key={value}>
                    {fileGrid(value, progress, value?.isUploading)}
                </div>)}
            </MyDisplayFiles>
            {/*<Dialog open={modelOpen}*/}
            {/*                 onClose={()=>setModelOpen(false)}*/}
            {/*                 title={modelFile?.filename}>*/}
            {/*    <div style={{width:'100%',height:'100%'}}>*/}
            {/*        <object data={modelFile?.url} width='100%' height='100%' style={{objectFit:'fill'}} aria-labelledby="objectUrl"/>*/}
            {/*    </div>*/}


            {/*</Dialog>*/}
        </MyContainer>)
}
